import {Dialog} from "../catalyst/dialog";

const sizes = {
  xs: 'sm:max-w-xs',
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-md',
  lg: 'sm:max-w-lg',
  xl: 'sm:max-w-xl',
  '2xl': 'sm:max-w-2xl',
  '3xl': 'sm:max-w-3xl',
  '4xl': 'sm:max-w-4xl',
  '5xl': 'sm:max-w-5xl',
  '6xl': 'sm:max-w-6xl',
}

type ModalProps = {
  visible: boolean,
  onClose?: Function,
  position?: 'right' | 'center' | 'left',
  size?: keyof typeof sizes,
  onSave?: Function,
  children?: any,
  maximized?: boolean,
  noscroll?: boolean,
  noBackdropDismiss?: boolean
}

export default function Modal ({
  visible,
  position,
  onClose,
  onSave,
  maximized = false,
  noscroll = false,
  children,
  size = 'lg',
  noBackdropDismiss = false
}: ModalProps) {

  return <Dialog open={visible} size={size} onClose={() => {
    if (onClose) onClose()
  }}>
    {children}
  </Dialog>

}
